<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="records.length">
          <table class="table table-sm table-hover mt-0">
            <thead>
            <tr>
              <th></th>
              <th>Дивизион</th>
              <th>Города</th>
              <th>Склад</th>
              <th width="175px">центр карты</th>
              <th>зоны на карте</th>
              <th>инкассация</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r, i) in sortArray(records, 'title')" :key="r.id">
              <td>{{ i + 1 }}</td>
              <td>
                <p>({{ r.id }}) {{ r.title }}</p>
                <p><i>{{ r.user?.short_name ?? r.user?.name }}</i></p>
                <p v-if="r.status === 2"><span class="badge badge-info">кредит</span></p>
              </td>
              <td>
                <p v-for="c in r.cities">{{ c.city?.name }}</p>
              </td>
              <td>{{ r.stores?.[0]?.store?.title }}</td>
              <td>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text small">Lat</span>
                  </div>
                  <input type="text" @change="() => r.to_update = true" v-model="r.settings.mapCenter[0]"
                         class="form-control">
                </div>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text small">Lon</span>
                  </div>
                  <input type="text" @change="() => r.to_update = true" v-model="r.settings.mapCenter[1]"
                         class="form-control">
                </div>
              </td>
              <td>
                <button type="button" @click="addNewZone(r)" class="btn btn-default btn-xs">добавить зону</button>
                <div class="mb-1 pb-1 border-bottom" v-for="a in (r.settings.mapAreas ?? [])">
                  <MapArea :area="a" :toUpdate="() => r.to_update = true"/>
                </div>
              </td>
              <td>
                <select @change="() => r.to_update = true" v-model="r.settings.cashOutType" class="form-control">
                  <option v-for="(o, type) in $platformConstants.cashOutTypes" :value="type">{{ o.title }}</option>
                </select>
              </td>
              <td></td>
            </tr>
            </tbody>
          </table>
          <div class="mt-1 text-right">
            <LoadingButton
              title="Сохранить"
              :loading="btnLoading"
              type="button"
              class="btn btn-success"
              color="white"
              :onClick="() => updateRecords()"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import MapArea from "@/views/divisions/components/MapArea.vue";

export default {
  components: {MapArea, LoadingButton},
  data() {
    return {
      loading: false,
      btnLoading: false,
      records: [],
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    addNewZone(division) {
      const index = this.records.findIndex((d) => d.id === division.id);
      console.log(index);
      if (!this.records[index].settings) this.$set(this.records[index], 'settings', {});
      if (!this.records[index].settings?.mapAreas) this.$set(this.records[index].settings, 'mapAreas', []);
      this.records[index].settings.mapAreas.push({coords: [], fillColor: null, strokeColor: null});
    },
    async updateRecords() {
      this.btnLoading = true;
      const {data} = await api.post('/new/divisions/settings', {records: this.records.filter((r) => r.to_update)});
      if (data.success) {
        await this.getRecords(true);
        toastr['success']('Настройки успешно сохранены');
      } else {
        toastr['warning'](data.message || 'Ошибка сохранения настроек');
      }
      this.btnLoading = false;
    },
    async getRecords(silent = false) {
      this.loading = !silent;
      const {data} = await api.index('/new/divisions/settings');
      if (data.success) {
        this.records = Object.values(data.records).filter((r) => r.type === 1 && (r.is_active || r.status === 2)).map((r) => {
          if (!r.settings) r.settings = {};
          if (!r.settings.mapCenter) r.settings.mapCenter = [0, 0];
          if (!r.settings.cashOutType) r.settings.cashOutType = 0;
          if (!r.settings.mapAreas) {
            r.settings.mapAreas = [];
            // r.settings.mapAreas = [{coords: [], fillColor: null, strokeColor: null}];
          }
          r.to_update = false;
          return r;
        });
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.input-group-prepend span.small {
  width: 48px;
}
</style>
